import React from 'react';
import PropTypes from 'prop-types';
import PriceMatrixRow from './PriceMatrixRow';

const PriceMatrixBody = (props) => {
  const { usCombined } = props
  const usQuantities = usCombined.quantities
  const usMatrix = usCombined.matrix
  const groups = ['grpa', 'grpb']

  const rows = usQuantities.map((qty, keyQty) => {
    // matrix[quantities][vendor-group][lead_time] => price
    const pricesByQuantity = usMatrix[qty.toString()];
    const hideQuantityCell = pricesByQuantity.length > 1;
    const rowSpanQuantityCell = pricesByQuantity.length;

    const listGroups = []
    groups.forEach((groupName) => {
      const priceRow = usMatrix[qty.toString()][groupName]
      listGroups.push(<PriceMatrixRow
        {...props}
        key={`${qty}-${groupName}`}
        row={keyQty}
        groupName={groupName}
        quantity={qty}
        priceRow={priceRow}
        hideQuantityCell={hideQuantityCell && listGroups.length > 0}
        rowSpanQuantityCell={rowSpanQuantityCell} />)
    })

    return listGroups
  });

  return (
    <tbody>
      {rows}
    </tbody>
  );
};

PriceMatrixBody.propTypes = {
  usCombined: PropTypes.shape({
    quantities: PropTypes.array.isRequired,
    matrix: PropTypes.object.isRequired,
  }).isRequired,
  quoteStep: PropTypes.string.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
}

export default PriceMatrixBody;
